module.exports = __webpack_public_path__ + "fonts/lato-italic-webfont.51473062.woff";